import * as React from 'react';
import {
	Container,
	LeftContainer,
	RightContainer
} from './styles/ToolbarStyle';
import { SurfaceColor } from '../../styles/global/css/Utils';

function Toolbar(props: {
  backgroundColor?: string;
  leftComponent?: JSX.Element;
  rightComponent?: JSX.Element;
  height?: string;
  borderBottom?: boolean;
}) {
	return (
		<Container
			height={props.height}
			borderBottom={props.borderBottom}
			backgroundColor={props.backgroundColor ? props.backgroundColor : SurfaceColor}
		>
			{props.leftComponent != null && (
				<LeftContainer>{props.leftComponent}</LeftContainer>
			)}
			{props.rightComponent != null && (
				<RightContainer>{props.rightComponent}</RightContainer>
			)}
		</Container>
	);
}

export default Toolbar;
